import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../api";
import {
  FaEdit,
  FaTrash,
  FaLaptop,
  FaDesktop,
  FaMobile,
  FaTabletAlt,
  FaPrint,
  FaShieldAlt
} from "react-icons/fa";
import { toast } from "react-toastify";
import AddAudit from "../../components/keamanan/AddAudit";
import { useAuth } from "../../context/AuthContext";
import DataAudit from "../../components/keamanan/DataAudit";
import { SipDropdown, SipSearch } from "../../components/form/SipControls";
import dayjs from "dayjs";
import "dayjs/locale/id";

// Set locale Indonesia untuk dayjs
dayjs.locale("id");

const AuditKeamanan = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterJenis, setFilterJenis] = useState("semua");
  const [filterTahun, setFilterTahun] = useState(new Date().getFullYear().toString());
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const { currentUser } = useAuth()
  const [form, setForm] = useState({
    id: "",
    nip: "",
    gupeg: "",
    jenis_perangkat: "",
    model: "",
    so: "",
    tgl: "",
    lokasi: "",
    petugas: currentUser.name,
  })
  const [form2, setForm2] = useState({
    id: "",
    audit_id: "",
    antivirus: "",
    so_update: "",
    firewall: "",
    enkripsi: "",
    original_soft: "",
    lainnya: "",
    hasil: "",
  })
  const [isEditMode, setIsEditMode] = useState(false);

  // Data dummy untuk audit perangkat pegawai
  const getData = async () => {
    try {
      setLoading(true);
      const response = await Api.get('/mon/audit-keamanan');
      setRows(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);



  const handleBack = () => {
    navigate(-1);
  };

  const postData = async () => {
    try {
      setLoading(true);

      // Siapkan data untuk dikirim ke server
      const auditData = {
        nip: form.nip,
        gupeg: form.gupeg,
        jenis_perangkat: form.jenis_perangkat,
        model: form.model,
        so: form.so,
        tgl: form.tgl,
        lokasi: form.lokasi,
        petugas: form.petugas,
        // Data audit keamanan
        antivirus: form2.antivirus,
        so_update: form2.so_update,
        firewall: form2.firewall,
        enkripsi: form2.enkripsi,
        original_soft: form2.original_soft,
        lainnya: form2.lainnya,
        hasil: form2.hasil
      };



      if (isEditMode && form.id) {
        // Mode edit - update data yang sudah ada
        await Api.put(`/mon/audit-keamanan/${form.id}`, auditData);
        toast.success("Data audit keamanan berhasil diperbarui!");
      } else {
        // Mode tambah - buat data baru
        await Api.post('/mon/audit-keamanan', auditData);
        toast.success("Data audit keamanan berhasil disimpan!");
      }

      // Refresh data setelah berhasil
      await getData();
      // Reset form dan mode
      resetForm();
      setLoading(false);

    } catch (error) {
      console.error("Error saat menyimpan data audit:", error);
      // Tampilkan notifikasi error
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        const errorMessage = isEditMode ?
          "Terjadi kesalahan saat memperbarui data audit" :
          "Terjadi kesalahan saat menyimpan data audit";
        toast.error(errorMessage);
      }
      setLoading(false);
    }
  };

  // Fungsi untuk reset form
  const resetForm = () => {
    setForm({
      id: "",
      nip: "",
      gupeg: "",
      jenis_perangkat: "",
      model: "",
      so: "",
      tgl: "",
      lokasi: "",
      petugas: currentUser.name,
    });

    setForm2({
      id: "",
      audit_id: "",
      antivirus: "",
      so_update: "",
      firewall: "",
      enkripsi: "",
      original_soft: "",
      lainnya: "",
      hasil: "",
    });

    setIsEditMode(false);
  };

  const getDeviceIcon = (jenis) => {
    switch (jenis.toLowerCase()) {
      case "laptop":
        return <FaLaptop className="text-blue-600" />;
      case "desktop":
        return <FaDesktop className="text-green-600" />;
      case "tablet":
        return <FaTabletAlt className="text-purple-600" />;
      case "mobile":
        return <FaMobile className="text-orange-600" />;
      case "printer":
        return <FaPrint className="text-gray-600" />;
      default:
        return <FaLaptop className="text-blue-600" />;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Aman":
        return "bg-green-100 text-green-800 border-green-200";
      case "Perlu Update":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "Berisiko":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  // Function untuk mendapatkan daftar tahun yang tersedia dari data
  const getAvailableYears = () => {
    if (!rows || rows.length === 0) return [];

    const years = rows
      .map(item => {
        if (!item.tgl) return null;
        return dayjs(item.tgl).year();
      })
      .filter(year => year !== null);

    const uniqueYears = [...new Set(years)].sort((a, b) => b - a);
    return uniqueYears;
  };

  // Filter data berdasarkan pencarian, jenis perangkat, dan tahun
  const filteredData = rows.filter(item => {
    const matchesSearch = item.gupeg.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.nip.includes(searchTerm) ||
      item.model.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.so.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesJenis = filterJenis === "semua" || item.jenis_perangkat.toLowerCase() === filterJenis.toLowerCase();

    // Filter berdasarkan tahun
    const matchesTahun = filterTahun === "semua" ||
      (item.tgl && dayjs(item.tgl).year().toString() === filterTahun);

    return matchesSearch && matchesJenis && matchesTahun;
  });



  const handleTambahAudit = (newAuditData) => {
    // Fungsi ini dipanggil setelah data berhasil disimpan
    // Data akan di-refresh melalui getData() di postData
    if (newAuditData) {
      console.log("Data audit baru berhasil ditambahkan:", newAuditData);
    }
  };

  const handleDetail = (id) => {
    toast.info(`Menampilkan detail audit ID: ${id}`);
  };

  const handleEdit = async (id) => {
    try {
      setLoading(true);
      const res = await Api.get(`/mon/audit-keamanan/${id}`);
      const data = res.data.data;

      // Set data form utama
      setForm({
        id: data.id,
        nip: data.nip,
        gupeg: data.gupeg,
        jenis_perangkat: data.jenis_perangkat,
        model: data.model,
        so: data.so,
        tgl: dayjs(data.tgl).format('YYYY-MM-DD'),
        lokasi: data.lokasi,
        petugas: data.petugas
      });

      // Set data form audit keamanan
      setForm2({
        id: data.id,
        audit_id: data.id,
        antivirus: data.antivirus || "",
        so_update: data.so_update || "",
        firewall: data.firewall || "",
        enkripsi: data.enkripsi || "",
        original_soft: data.original_soft || "",
        lainnya: data.lainnya || "",
        hasil: data.hasil || "",
      });

      // Set mode edit dan buka modal
      setIsEditMode(true);
      setIsModalOpen(true);
      setLoading(false);

    } catch (error) {
      toast.error("Gagal mengambil data untuk diedit");
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    // Konfirmasi sebelum menghapus
    const confirmDelete = window.confirm("Apakah Anda yakin ingin menghapus data audit ini?");

    if (!confirmDelete) {
      return; // Batalkan jika user tidak konfirmasi
    }

    try {
      setLoading(true);
      await Api.delete(`/mon/audit-keamanan/${id}`);
      toast.success("Data audit berhasil dihapus!");
      await getData();
    } catch (error) {
      console.error("Error menghapus data:", error);
      toast.error("Gagal menghapus data audit");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* ==================== HEADER SECTION ==================== */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div className="bg-primary px-6 py-8 md:px-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              {/* Judul Halaman */}
              <div className="text-white animate__animated animate__fadeInLeft animate__delay-2s">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 bg-white/20 rounded-lg animate__animated animate__pulse animate__infinite animate__slower">
                    <FaShieldAlt className="text-xl" />
                  </div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    Audit Keamanan Sistem Informasi
                  </h1>
                </div>
                <p className="text-primary text-sm md:text-base">
                  Pantau dan kelola keamanan perangkat sistem sekolah dan pegawai
                </p>
              </div>

              {/* Tombol Kembali */}
              <button
                onClick={handleBack}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-3 rounded-xl hover:bg-white/20 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                <span className="font-medium">Kembali</span>
              </button>
            </div>
          </div>
        </div>

        {/* ==================== STATISTIK CARDS ==================== */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm font-medium">Total Perangkat</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">{filteredData.length}</p>
              </div>
              <div className="p-3 bg-blue-100 rounded-xl">
                <FaLaptop className="text-blue-600 text-xl" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm font-medium">Status Aman</p>
                <p className="text-2xl font-bold text-green-600 mt-1">
                  {filteredData.filter(item => item.hasil === "Aman").length}
                </p>
              </div>
              <div className="p-3 bg-green-100 rounded-xl">
                <FaShieldAlt className="text-green-600 text-xl" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm font-medium">Perlu Update</p>
                <p className="text-2xl font-bold text-yellow-600 mt-1">
                  {filteredData.filter(item => item.hasil === "Perlu Update").length}
                </p>
              </div>
              <div className="p-3 bg-yellow-100 rounded-xl">
                <FaEdit className="text-yellow-600 text-xl" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm font-medium">Berisiko</p>
                <p className="text-2xl font-bold text-red-600 mt-1">
                  {filteredData.filter(item => item.hasil === "Berisiko").length}
                </p>
              </div>
              <div className="p-3 bg-red-100 rounded-xl">
                <FaTrash className="text-red-600 text-xl" />
              </div>
            </div>
          </div>
        </div>

        {/* ==================== SEARCH AND FILTER SECTION ==================== */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
          <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
            {/* Search Bar */}
            <div className="w-full min-w-0 flex-1 xl:max-w-md">
              <SipSearch
                placeholder="Cari nama pegawai, NIP, model, atau sistem operasi..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Filters */}
            <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:flex xl:w-auto xl:flex-wrap">
              <SipDropdown
                value={filterJenis}
                onChange={(e) => setFilterJenis(e.target.value)}
                className="xl:w-48"
                options={[
                  { label: "Semua Perangkat", value: "semua" },
                  { label: "Laptop", value: "laptop" },
                  { label: "Desktop", value: "desktop" },
                  { label: "Tablet", value: "tablet" },
                  { label: "Mobile", value: "mobile" },
                  { label: "Printer", value: "printer" },
                ]}
              />
              <SipDropdown
                value={filterTahun}
                onChange={(e) => setFilterTahun(e.target.value)}
                className="xl:w-40"
                options={[
                  { label: "Semua Tahun", value: "semua" },
                  ...getAvailableYears().map((year) => ({
                    label: String(year),
                    value: year.toString(),
                  })),
                ]}
              />
              <AddAudit
                handleTambahAudit={handleTambahAudit}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                form={form}
                setForm={setForm}
                form2={form2}
                setForm2={setForm2}
                postData={postData}
                isEditMode={isEditMode}
                resetForm={resetForm}
              />
            </div>
          </div>
        </div>

        {/* ==================== AG GRID TABLE SECTION ==================== */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <DataAudit
            rows={filteredData}
            getDeviceIcon={getDeviceIcon}
            handleDelete={handleDelete}
            handleDetail={handleDetail}
            handleEdit={handleEdit}
            loading={loading}
          />
        </div>

        {/* Empty State */}
        {filteredData.length === 0 && (
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-12 text-center">
            <FaShieldAlt className="mx-auto text-6xl text-gray-300 mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Tidak ada data audit</h3>
            <p className="text-gray-500 mb-6">
              {searchTerm || filterJenis !== "semua"
                ? "Tidak ada data yang sesuai dengan filter yang dipilih"
                : "Belum ada data audit keamanan perangkat yang tersedia"}
            </p>

          </div>
        )}
      </div>
    </div>
  );
};

export default AuditKeamanan;